<template>
  <div class="OpeningAdvertisement">
    <div class="OpeningAdvertisement-title">
      <div class="title">广告通知-开场广告</div>
      <div>开启状态：
        <a-switch
            style="margin-right: 10px"
            v-model="isShow"
            @change="switchChange(isShow)"
            checked-children="开"
            un-checked-children="关"
            default-checked />
      </div>
    </div>
    <div class="OpeningAdvertisement-content">
      <div class="uploadImg" style="position: relative">
        <div style="position: absolute;width: 100%;text-align: center;" v-if="!relayImg" @click="openModelPic">
          <div style="font-size: 40px;color: #d2d0d0;margin-top: 200px">+</div>
          <div style="font-size: 16px;color: #d2d0d0">上传海报</div>
        </div>
<!--        <input-->
<!--            id="surfacePlot"-->
<!--            class="upImg"-->
<!--            accept="image/*"-->
<!--            type="file"-->
<!--            @change="surfacePlotBtn"-->
<!--            ref="surfacePlot" />-->
        <div class="uploadImg_img">
          <img
              v-if="relayImg"
              alt=""
              style="width: 98%;
              max-height: 690px;
              border-radius: 5px;
              margin-top: 2px;
              background-color: #fff;"
              :src="relayImg"
          />
        </div>
        <div style="position: absolute;top: 5px;right: 10px;z-index: 999">
          <a-icon v-show="relayImg" @click="delCover" style="color: #f82c2c;cursor: pointer;" type="close-circle" />
        </div>
      </div>

      <div style="margin-left: 30px">
        <div>时长</div>
        <div style="margin-top: 20px;margin-bottom: 20px;position: relative">
          <a-input-number v-model="beginImageTime" style="width: 200px;border-radius: 0" placeholder="请输入" ></a-input-number>
          <a-button style="background-color: #F5F5F5;border-radius: 0;position: absolute;top: 0;border-left: none">
            秒
          </a-button>
        </div>
        <div><a-button @click="save" type="primary">保存</a-button></div>
      </div>
    </div>
    <pictureDialog
        :visible="visiblePic"
        v-on:closeMain="closeMainPic"
        v-on:checkList="checkListPic">
    </pictureDialog>
  </div>
</template>

<script>
import {update} from "@/utils/update";
import {updMeetingBeginImg, liveMettingSpecials} from "@/service/liveManage";
import pictureDialog from "@/components/Material/pictureDialog";

export default {
  name: "OpeningAdvertisement",
  components:{
    pictureDialog
  },
  data(){
    return{
      visiblePic:false,
      isShow:false,
      relayImg:'',
      beginImageTime:'',
      meetingCode:null,
      picList:[],
    }
  },
  computed:{
    funList(){
      return this.$store.state.funList;
    }
  },
  created() {
    this.meetingCode = this.$route.query.meetingCode;
    this.getContent(); //获取开场广告内容
  },
  methods:{
    openModelPic(){
      this.visiblePic = true;
    },
    closeMainPic(val){
      this.visiblePic = val;
    },
    checkListPic(val){
      this.picList = val[0].url;
      this.relayImg = this.picList;
    },
    //通过funId获取介绍内容
    async getContent() {
      let data = {
        page_no:1,
        page_size:1,
        type:'SINGLE',
        meetingCode:this.meetingCode,
      }
      const response = await liveMettingSpecials(data);
      if(response.code === 0){
        let row = response.data.rows[0];
        this.relayImg = row.beginImageDetail ? row.beginImageDetail[0]:null;
        this.beginImageTime = row.beginImageTime;
       this.isShow = row.isBeginImage ? true :false;
      }
    },
    save(){
      if(this.relayImg){
        let data = {
          "meetingCode":this.meetingCode,//会议的code值
          // "isBeginImage":1, //1开启  0关闭
          "beginImageDetail":[this.relayImg],
          "beginImageTime":this.beginImageTime//时长
        }
        this.putStreamFuncs(data)
      }else {
        this.$message.warning("请先上传开场广告图！")
      }
    },
    // 修改直播间设置功能列表
    async putStreamFuncs(data) {
      const response = await updMeetingBeginImg(data)
      if(response.code === 200){
        this.$message.success("修改成功！");
        //刷新数据
        await this.getContent()
      }else {
        this.$message.warning(response.message);
      }
    },
    switchChange(isOpen){
      this.isShow = isOpen;
      let data = {
        "meetingCode":this.meetingCode,//会议的code值
        "isBeginImage":isOpen ? 1:0, //1开启  0关闭
        // "beginImageDetail":[this.relayImg],
        // "beginImageTime":this.beginImageTime//时长
      }
      this.putStreamFuncs(data);
    },
    async surfacePlotBtn() {
      let inputDOM = this.$refs.surfacePlot.files[0];
      //判断图片大小
      if (inputDOM.size < 1048576) {
        const image = await update(inputDOM)
        if (image.code === 0) {
          this.relayImg = image.data.url
          this.$message.success("上传成功")
        } else {
          this.$message.warning("上传失败")
        }

      } else {
        this.$message.warning("请上传小于1M的图片！")
      }
      document.getElementById('surfacePlot').value = null
    },
    delCover(){
      this.relayImg = '';
    },
  }
}
</script>

<style scoped lang="scss">
.OpeningAdvertisement{
  width: 100%;
  //border-left: 1px solid #d9d9d9;
  .OpeningAdvertisement-title{
    height: 50px;line-height: 50px;
    border-bottom: 1px solid #F5F5F5;
    display: flex;
    justify-content: space-between;
    .title{
      font-weight: bold;
      margin-left: 10px;
    }
  }
  .OpeningAdvertisement-content{
    padding: 20px;
    display: flex;
    .uploadImg{
      border: #DDDDDD 2px dashed;
      width: 280px;
      min-height: 700px;
      border-radius: 5px;
      text-align: center;
      padding-top: 30px;
      background-color: #fafafa;
    }
    .uploadImg_img{
      position: absolute;
      top: 0;
      width: 100%;
    }
    .upImg{
      width: 100%;
      height: 100%;
      opacity: 0;
      position: absolute;
      top: 0;
      left: 0;
      cursor: pointer;

    }
  }
}
</style>
